import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WriterActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Writer/WriterBrowser")
	}

	render() {
		return (
			<Activity 
				name="Writer"
				RenderedComponent={this.RenderedComponent}
                context="Writer"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WriterActivity)
